import { defineStore } from "pinia";
import { shallowRef } from "vue";
import IdentityBinding from "@views/login/IdentityBinding";
const useLogin = defineStore("login", {
  state: () => ({
    isLogin: false,
    showVisible: false,
    headImg:"https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
    token: "",
    username: "",
    roleId: -1,
    userId: "",
    agencyId: undefined,
    code: "",
    component: shallowRef(IdentityBinding),
    isShowGame: true
  }),
  persist: true,
  getters: {},

  actions: {},
});

//暴露这个useCounter模块
export default useLogin;
